import { render } from "./CategoryCardLoader.vue?vue&type=template&id=4fefc47c"
import script from "./CategoryCardLoader.vue?vue&type=script&lang=js"
export * from "./CategoryCardLoader.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/zaytoon-mtn-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__